<template>
  <div class="section">
    <div class="columns">
      <div class="column is-one-third">
        <div v-for="page in training">
            <router-link :to="'/' + page.title_slug">{{page.title}}</router-link>
        </div>
      </div>
      <div class="column">
        <transition name="component-fade" mode="out-in">
        <div v-if="$route.params.id" :key="trainingpage.title_slug">
          <div class="contact" >
            <vue-markdown v-bind:source="trainingpage.content"></vue-markdown>
          </div>
        </div>

        </transition>
      </div>
    </div>
    <div v-if="$route.params.id">
      <vue-headful :title="trainingpage.title" />
    </div>


  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import VueMarkdown from 'vue-markdown'
import vueHeadful from 'vue-headful'

export default {
  name: 'TrainingList',
  computed: {
    ...mapGetters(['training', 'getTrainingById']),
    trainingpage() {
      return this.getTrainingById(this.$route.params.id);
    }
  },
  components: {
    VueMarkdown,
    vueHeadful
  },
  mounted() {

  }
}
</script>
<style scoped>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity 0.25s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
  margin-right: 15px;
}
a.router-link-active {
  color: #42b983;
}
a.router-link-exact-active {
  color: #42b983;
}
</style>
